import React from "react"
import PropTypes from "prop-types"
import { Nav } from "react-bootstrap"

import { TabTitle } from "./TabTitle"
import { id_accessor, isLTPM } from "../../../../components/shared_components_registration"

/*
  Renders a tab for each reactor at the site
*/

const registration = {
  err_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.server.error" }) : "Error Occurred!"),
  loading_label: (intl, run_id) =>
    isLTPM ? intl.formatMessage({ id: "general.loading" }) : `Loading: Run ${run_id}`,
  show_run_names: (run) =>
    isLTPM ? !((run.source_type && run.source_type === "System") || run.placeholder) : true,
}

export const TabTitles = ({ availableRuns, defaultActiveKey, defaultRunLoaded, intl }) => {
  return (
    <Nav variant="tabs" defaultActiveKey={defaultActiveKey}>
      {availableRuns.length === 0 ? (
        <TabTitle intl={intl} eventKey={defaultActiveKey} title={defaultActiveKey} disabled={true} />
      ) : (
        <>
          {availableRuns.map((run) => {
            const loading = run.loading,
              run_id = run[id_accessor],
              tabTitle = run.err
                ? `${registration.err_label(intl)}...`
                : loading
                  ? `${registration.loading_label(intl, run_id)}...`
                  : registration.show_run_names(run)
                    ? `${run.reactor} - ${run.name}`
                    : run.reactor

            return (
              <TabTitle
                intl={intl}
                key={`Run${run_id}`}
                eventKey={`${run_id}`}
                title={tabTitle}
                disabled={!!(loading || !defaultRunLoaded)}
                isPlaceholder={run.placeholder}
                missing_parental_information={run.missing_parental_information}
              />
            )
          })}
        </>
      )}
    </Nav>
  )
}

TabTitles.propTypes = {
  availableRuns: PropTypes.array.isRequired,
  defaultActiveKey: PropTypes.string.isRequired,
  defaultRunLoaded: PropTypes.bool.isRequired,
  intl: PropTypes.object,
}
